import axios from "axios";
import { baseService } from "../base";
import { TGetPresignedParams, TPresignedUrl } from "./upload.types";

export const uploadServices = {
  uploadImages: async (formData: FormData) => {
    const { data } = await baseService.post("/images", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return data;
  },

  updateImage: async (
    id: string,
    updateData: {
      staffId?: string;
      name?: string;
      url?: string;
      size?: string;
      inventoryId?: string;
    }
  ) => {
    const { data } = await baseService.patch(`/images/${id}`, updateData);
    return data;
  },

  getPresignedUrl: async (params: TGetPresignedParams) => {
    const { data } = await baseService.post<TPresignedUrl>(
      "/images/presign",
      params
    );
    return data;
  },

  getPresignedUrls: async (params: TGetPresignedParams[]) => {
    const { data } = await baseService.post<TPresignedUrl[]>(
      "/images/presign/multiple",
      {
        files: params,
      }
    );
    return data;
  },

  uploadFileToPresignedUrl: async (presignedUrl: string, file: File) => {
    const { data } = await axios.put(presignedUrl, file, {
      headers: {
        "Content-Type": file.type,
      },
    });
    return data;
  },
};
